export default "__VITE_ASSET__CZFK6KP9__"